'use strict';
(function($) {
    $.widget(
      'Vetology.CronMonitor',
        {
            "options": {
                table: null,
            },
            _init: function() {
                var o = this;
                this.options.table = $("#cron-job-table").DataTable( {
                    'ajax': {
                        url: "/admin/cron-monitor/data",
                        type: 'get',
                        timeout: 15000,
                        dataSrc: function(json) {
                            return json.data;
                        }
                    },
                    columns: [
                        { data: 'id' },
                        { data: 'name' },
                        { data: 'server' },
                        { data: {
                                _: 'lastStarted.display',
                                sort: 'lastStarted.timestamp'
                            }
                        },
                        { data: {
                            _: 'lastFinished.display',
                            sort: 'lastFinished.timestamp'
                            }
                        },
                        { data: 'duration' },
                        { data: 'status' },
                        { data: {
                                // need to define orthagonal data for sorting/filtering
                                _: 'lastError.display',
                                sort: 'lastError.timestamp',
                                filter: 'lastError.label'
                            }
                        }
                    ],
                    'autowidth': true,
                    'scrollx': true,
                    'colReorder': true,
                    'order': [[4, "desc"]],
                });

                o._createColumnFilters();

                setInterval(function() {
                    o.options.table.ajax.reload(null, false);
                }, 15000);

                o._addEventListeners();
            },
            _addEventListeners: function() {
                let o = this;

                $("#cron-job-table thead th input, #cron-job-table thead th select").each(function(i, el) {
                    $(el).on('keyup change', function(e) {
                        let colNum = $(e.currentTarget).parent().index();
                        if (o.options.table.column(colNum).search() !== e.currentTarget.value) {
                            if (e.currentTarget.tagName == "SELECT") {
                                // need to do a regex search to include errors of selected type and later
                                o.options.table.column(colNum).search(e.currentTarget.value, true, false).draw();
                            } else {
                                o.options.table.column(colNum).search(e.currentTarget.value).draw();
                            }
                        }
                    });

                    // disregard clicking in input for sorting
                    $(el).on('focus click', function(e) {
                        e.stopImmediatePropagation();
                        e.stopPropagation();
                        e.preventDefault();
                    });
                });

            },

            /**
             * _createColumnFilters
             *
             * @description Creates the column filters for the text searches
             *
             * @private
             */
            _createColumnFilters: function() {
                var o = this;

                o._createColumnInputFilter('.id-col', 'ID');
                o._createColumnInputFilter('.name-col', 'Name');
                o._createColumnInputFilter('.server-col', 'Server');
            },

            /**
             * _createColumnInputFilter
             *
             * @description creates individual filter
             * @param cls
             * @param placeholder
             * @private
             */
            _createColumnInputFilter: function(cls, placeholder) {
                let $th = $(cls);
                let $input = $("<input type='text' placeholder='" + placeholder + "'/>");
                $th.append($input);
            },


        }
    );
})(jQuery);
